module.exports={name:"第8章 ラムダとヴェルダ",number:8};